import React, { useState, useEffect } from 'react';
import './App.css';
import { useNavigate, Link } from 'react-router-dom';
import tobslogo from './images/tobs-txt.svg';
import setcastLogo from './images/Setcast_Logo_Icon_White_RGB.svg';
import { useAuth } from './contexts/AuthContext';

function LoginForm() {
  const navigate = useNavigate();
  const { login, forgotPassword, error, setError } = useAuth();
  const [resetFeedback, setResetFeedback] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    // Check for token in localStorage on component mount
    const token = localStorage.getItem('token');
    console.log('Token presence on login page load:', !!token);
  }, []);

  const renderErrorMessage = () => {
    if (error || localError) {
      return <p className="error">{error || localError}</p>;
    }
    return null;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setLocalError('');
    const { uname, pass } = document.forms[0];

    if (!uname.value || !pass.value) {
      setLocalError('Email and password are required');
      setIsLoading(false);
      return;
    }

    try {
      console.log('Submitting login form for:', uname.value);
      await login(uname.value, pass.value);
      
      // Check if token was saved after login
      const token = localStorage.getItem('token');
      console.log('Token saved after login attempt:', !!token);
      
      // No need to navigate here as it's handled in the AuthContext
    } catch (error) {
      // Error handling is done in the AuthContext
      console.error("Login form error:", error);
      setLocalError(error.message || 'Login failed. Please check your credentials and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordReset = async (email) => {
    if (!email) {
      setResetFeedback('Please enter your email address first.');
      return;
    }

    try {
      await forgotPassword(email);
      setResetFeedback('Password reset email sent successfully.');
    } catch (error) {
      console.error('Error sending password reset email:', error);
      setResetFeedback('Error sending password reset email. Please try again later.');
    }
  };
      
  return (
    <div className="loginForm">
      <form onSubmit={handleSubmit}>
        <div className="loginForm-container">
          <img style={{height:150}} src={tobslogo} alt="Tobs Logo" />
          <label>
            <input type="text" name="uname" placeholder="email" required />
          </label>
  
          <label>
            <input type="password" name="pass" placeholder="password" required />
          </label>
          {renderErrorMessage()}
          <Link to="/forgot-password" className="password-reset-link">
            Forgot your password?
          </Link>
          <p className="password-reset-link" style={{ marginTop: '10px' }}>
            {resetFeedback}
          </p>
          <button type="submit" className="big-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </form>
      <div className="footer-logo-container">
        <img style={{ height: 60 }} src={setcastLogo} alt="Setcast Logo" />
      </div>
    </div>
  );
}

export default LoginForm;